export default {
  bookAgainCard: {
    offers: 'Offers {{SERVICES}}',
    ucOnly: 'Offers in-person visits',
    videoOnly: 'Offers video visits',
    both: 'Offers in-person and video visits',
    careTypes: {
      uc: 'in-person visits',
      covid: 'COVID tests',
      video: 'video visits',
    },
  },
  availability: {
    future: 'Available {{date, moment::ddd MMM Do}}',
    lastBooked: 'Last booked {{date, relative}}',
    bookAppointment: 'Book appointment',
    loading: 'Loading availability',
    noAvailability: 'Not available today or tomorrow',
    today: 'Available today, {{date, moment::MMM Do}}',
    tomorrow: 'Available tomorrow, {{date, moment::MMM Do}}',
  },
  locationChoiceCard: {},
  careTeam: {
    pageTitle: 'Book again',
    careTypes: {
      uc: 'Urgent care',
      video: 'Video visit',
      covid: 'COVID test',
    },
    doctorIllustrationAlt: 'Illustration of doctor with a heart icon on top',
    explainer: `{{name}}'s previously visited doctors and clinics will be added to this
    page for easy rebooking.`,
    switchProfiles: `To view other family members' history, <0>switch profiles.</0>`,
  },
  getCareNow: {
    titles: {
      covid: 'Where do you want to go to get a COVID test?',
      video: 'Who would you like to talk to?',
      uc: 'Where would you like to go?',
      provider: 'Who would you like to see?',
      lab: 'What lab would you like to book?',
    },
    videoVisitExplainer: {
      cta: 'What can be treated over video?',
      use: 'Use video visits for:',
      dontUse: 'Issues not treated:',
    },
    sections: {
      previosulyVisited: 'Previously visited:',
      needCareNow: 'Need care now?',
    },
    searchCta: {
      title: 'Continue with search',
      subtitles: {
        uc: 'Find nearby urgent care',
        video: 'Find a local clinic offering video visits.',
        covid: 'Find nearby locations offering COVID tests',
        provider: 'Find a nearby provider',
        lab: 'Find a nearby lab',
      },
    },
    solvPlusCard: {
      iconAlt: 'Teal camera icon with a badge that says plus',
      subtitle: 'Start a visit in minutes. $49 with membership.',
      timeCta: 'Available in the next 30 minutes',
      titles: {
        uc: 'Talk to a provider now',
        videoAfterHours: 'See next available provider',
        video: 'Next available provider',
      },
    },
    solvNowCard: {
      iconAlt: 'Illustration of a video call on a phone',
      subtitle: '$79 or $49 for Plus members',
      timeCta: 'Available now',
      titles: {
        uc: 'Talk to a provider now',
        videoAfterHours: 'See next available provider',
        video: 'Next available provider',
      },
    },
  },
  manage: {
    title: "{{NAME}}'s visits",
    tabs: {
      upcoming: 'Upcoming',
      past: 'Past',
    },
    yearTitle: '{{YEAR}} visits',
    emptyState: {
      title: {
        past: 'No past visits',
        upcoming: 'No upcoming visits',
        subtitile: 'When you’re ready to find and book care, we’ll be here to help.',
      },
      cta: 'Find care now',
      switchProfilesCta: `Looking for someone else's visit? <0>Change profiles</0>`,
    },
    pastAppointmentCard: {
      visitSummary: {
        updatePrompt: '<0>Update</0> your copy of your visit summary',
        downloadPrompt: '<0>Securely download</0> a copy of your visit summary',
        viewPrompt: 'View visit summary',
        pending:
          "Your provider is creating a visit summary. You'll receive an email once it's ready (usually within 30 minutes).",
      },
    },
  },
  searchModal: {
    titles: {
      findCare: 'Find care',
    },
  },
  header: {
    getCare: 'Get care for {{FIRST_NAME}}',
    upcomingVisit: '{{FIRST_NAME}} has an upcoming visit',
    noUpcomingVisit: '{{FIRST_NAME}} has no upcoming visits',
    loadingVisits: `Loading {{FIRST_NAME}}'s visits`,
  },
  solvPlusEntrypoint: {
    title: 'Talk to a provider now',
    subtitle: 'Get affordable care from top providers in minutes, 24/7.',
    cta: 'Start a video visit',
  },
  solvPremiumEntrypoint: {
    title: 'Instant video visit',
    subtitle:
      'Connect to a top provider in {{PREMIUM_TELEMED_SLA_MINUTES}} minutes or less with {{SOLV_NOW_NAME}}.',
    cta: 'Begin video visit',
    solvMembershipUpsell: 'Only {{TELEMED_VISIT_COST_STRING}} for {{MEMBERSHIP_NAME}} members.',
    linkCta: 'Learn more',
  },
  home: {
    bookAgain: {
      title: 'Book again',
      seeAll: 'see all',
    },
    findCare: {
      title: 'Find care near you',
    },
    services: {
      title: 'Ways we can help',
    },
  },
  navTiles: {
    uc: {
      title: 'Urgent care',
      subtitle: 'For minor injuries and illnesses',
    },
    video: {
      title: 'Video visit',
      subtitle: 'Get care from anywhere',
    },
    covidTest: {
      title: 'COVID test',
      subtitle: 'For travel and diagnosis',
    },
    flu: {
      title: 'Flu shot',
      subtitle: 'For the {{YEAR}} flu season',
    },
    labTest: {
      title: 'Lab test',
      subtitle: 'Find local clinics offering lab tests',
    },
    search: {
      title: 'Find the right care',
      subtitle: 'Symptom, service, or provider',
    },
    triage: {
      title: 'Symptom Checker',
      subtitle: 'Find possible causes and get advice',
    },
  },
  appointmentCard: {
    aptTimeCopy: {
      postVisit: 'Your visit is complete',
    },
    descriptiveText: {
      completePaperworkBeforeCall: 'Complete paperwork before joining the call:',
      waitForProvider: 'Please join the call and wait for the provider:',
      joinBeforeScheduledStart: 'Join a few minutes before scheduled start time:',
      completePaperworkBeforeArrival: 'Complete paperwork before you arrive:',
      yourPaperworkSent: 'Your paperwork has been sent to the clinic.',
      directionsRescheduleCancel: 'Get directions, reschedule or cancel your visit:',
      checkInAtArrival: 'Please check-in once you’ve arrived at the clinic:',
      checkedIn: 'You’ve been checked into the clinic.',
      letUsKnow: 'Please let us know how your visit went:',
      takeNote: 'Take note of what the doctor said during your visit',
      testResultsAvailable: '{{patientName}}’s test results are available:',
      waitingForVisitSummary:
        "Your provider is creating a visit summary. You'll receive an email once it's ready to download and view.",
      downloadSummary: 'Securely download a copy of your visit summary',
      updateSummary: 'An update to your visit summary is available',
      viewSummary: 'Your visit summary was successfully downloaded',
      waitForExternalTelemed: '{{locationName}} will reach out with instructions on how to join.',
    },
    callToActionCopy: {
      completePaperwork: 'Complete paperwork',
      joinWaitingRoom: 'Join waiting room',
      joinCall: 'Join call',
      manageVisit: 'Manage visit',
      checkIn: 'Check-in to the clinic',
      viewSpot: 'View your spot in line',
      rateAndReview: 'Rate and review',
      addVisitNotes: 'Add visit notes',
      viewVisitDetails: 'View visit details',
      viewTestResults: 'View test results',
      saveVisitSummary: 'Save visit summary',
      updateVisitSummary: 'Update visit summary',
      downloadingVisitSummary: 'Downloading and Saving...',
      viewVisitSummmary: 'View visit summary',
      default: 'View visit details',
    },
  },
  premiumVisitSection: {
    title: 'Get care now',
    memberTitle: 'Your exclusive Plus benefits',
  },
  inPersonPremium: {
    accountCard: {
      title: 'Local in-person visits',
      subtitle: 'No-wait office visits at clear, upfront self-pay prices.',
      genericCta: 'Book visit now',
    },
    upsellAlert: {
      title: 'Amazing care. No surprise bills.',
      subtitle: 'Get in-person or virtual care today at member-exclusive prices.',
    },
    memberAlert: {
      title: 'New Plus benefit! See local providers w/ members-only prices.',
      subtitle: 'Visit fees apply.',
    },
  },
};
